import instance from "@/plugins/axios";
import { ResponseResult } from "@/core/models/response-result";
import { Audit } from "../models/audit";
import { AuditState } from "../models/audit-state";
import { TableState } from "@/core/models/table-state";
import {
  AbstractAuditRemoteDataSource,
  GetAuditsParams,
} from "@/modules/audit/remote/AbstractAuditRemoteDataSource";

export class AuditRemoteDataSource implements AbstractAuditRemoteDataSource {
  async getAudits(params: GetAuditsParams): Promise<ResponseResult> {
    try {
      const response = (
        await instance.get<ResponseResult<any>>("Audits", { params })
      ).data;
      if (!response.isSuccess) return response;
      response.data = this.convertFromJsonToTableState(response.data);

      return response;
    } catch (error) {
      console.error(error);
      return ResponseResult.defaultError(error);
    }
  }

  async getAudit(id: number): Promise<ResponseResult> {
    try {
      const response = (await instance.get<ResponseResult<any>>("Audits/" + id))
        .data;
      if (!response.isSuccess) return response;
      response.data = this.convertFromJsonToUser(response.data);

      return response;
    } catch (error) {
      console.error(error);
      return ResponseResult.defaultError(error);
    }
  }

  convertFromJsonToTableState(data: any): TableState<Audit> {
    return {
      pageNumber: data.pageNumber,
      pageSize: data.pageSize,
      totalItems: data.totalItems,
      totalPages: data.totalPages,
      items: this.convertFromJsonToAuditList(data.items),
    };
  }

  convertFromJsonToAuditList(data: any[]): Audit[] {
    return data.map((item) => this.convertFromJsonToUser(item));
  }

  convertFromJsonToUser(data: any): Audit {
    return {
      id: data.id,
      actionDate: data.actionDate,
      actionType: AuditState.getaudittateByValue(data.actionType),
      changedColumns: data.changedColumns,
      entityName: data.entityName,
      newValues: data.newValues,
      entityId: data.entityId,
      externalEntityId: data.externalEntityId,
      oldValues: data.oldValues,
      userId: data.userId,
    };
  }
}
